import createCache from "@emotion/cache";

// Create a standard cache
const cache = createCache({
  key: "muirtl",
});

export default cache;
